import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DocumentSidebarType } from '../../views/ProcessDocument/DocumentSidebar/models'

import { RootState } from '../store'

interface DisplayedDocumentSidebar {
  type: DocumentSidebarType
  title: string
  icon: string
}

interface DocumentSidebarState {
  displayedSidebar: DisplayedDocumentSidebar | null
}

const initialState: DocumentSidebarState = {
  displayedSidebar: null,
}

export const documentSidebarSlice = createSlice({
  name: 'documentSidebar',
  initialState,
  reducers: {
    displayDocumentSidebar: (state, action: PayloadAction<DisplayedDocumentSidebar>) => {
      state.displayedSidebar = action.payload
    },
    hideDocumentSidebar: (state) => {
      state.displayedSidebar = null
    },
    resetDocumentSidebar: () => initialState,
  },
})

export const { displayDocumentSidebar, hideDocumentSidebar, resetDocumentSidebar } = documentSidebarSlice.actions

export const selectDisplayedDocumentSidebar = (state: RootState) => state.processDocument.documentSidebar.displayedSidebar
